import { NewTableColumn, NewTableDefaultDataItem, NewTableGetId } from '@common/components/new-table/new-table.types';
import { Row as RowType } from '@tanstack/react-table';
import * as React from 'react';
import cx from 'classnames';
import { getTestAttributes } from '@common/utils/tests';

import './row.styles.scss';

export type RowProps = {
  getId: {
    root: string;
    cell: NewTableGetId['bodyCell'];
  };
  index: number;
  selected?: boolean;
  model: RowType<NewTableDefaultDataItem>;
  onContextMenu?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
  onClick?: (params: { item: NewTableDefaultDataItem; e: React.MouseEvent<HTMLTableRowElement> }) => void;
};

export const Row: React.FC<RowProps> = (props) => {
  const { model, onClick, selected, onContextMenu, index, getId } = props;

  const handleClick = React.useCallback((e: React.MouseEvent<HTMLTableRowElement>) => {
    if (onClick) {
      onClick({
        item: model.original,
        e,
      });
    }
  }, [model.original, onClick]);

  return (
    <tr 
      className={cx(
        'NewTable__body__row', 
        { 
          'NewTable__body__row--even': (index + 1) % 2 === 0,
          'NewTable__body__row--selected': selected,
        }
      )} 
      {...getTestAttributes({ id: getId.root })}
      onClick={onClick ? handleClick : undefined}
      onContextMenu={onContextMenu}
    >
      {model.getVisibleCells().map((cell, columnIndex) => {
        let content: React.ReactNode;

        if (cell.column.columnDef.cell) {
          if (typeof cell.column.columnDef.cell === 'function') {
            content = cell.column.columnDef.cell(cell.getContext())
          } else {
            content = cell.column.columnDef.cell;
          }
        } else {
          content = model.getValue(cell.column.id);
        }

        return (
          <td
            key={cell.id}
            style={{
              minWidth: cell.column.getSize(),
              width: cell.column.getSize(),
              maxWidth: cell.column.getSize(),
            }}
            {...getTestAttributes({ 
              id: getId.cell(
                cell.column as unknown as NewTableColumn<NewTableDefaultDataItem>,
                columnIndex,
                model.original,
                index,
              ) 
            })}
            title={(typeof content === 'string' || typeof content === 'number') ? content?.toString() : undefined}
            className="NewTable__body__row__cell"
          >
            {content}
          </td>
        );
      })}
    </tr>
  );
};